module.exports = __webpack_public_path__ + "img/lounge-motion.3728cf22.png";